import moment, { type Moment } from 'moment';
import type { ID } from 'types';
import { DateTimeFormatRepository } from 'consts/general';
import { when } from 'util/support';
import type { UboIdentity, WithFieldsStatuses } from 'features/onboarding/types';

export class Identity implements WithFieldsStatuses {
    public readonly fullName: string;
    public readonly dateOfBirth: Moment | null;
    public readonly residentialAddress: string;
    public readonly nationality: string | null;
    public readonly identityFileKey: string | null;
    public readonly addressFileKey: string | null;
    public readonly pki: ID | undefined;
    public readonly fieldsStatuses: WithFieldsStatuses['fieldsStatuses'];
    public readonly legalForm: string | null;

    public constructor({
        fullName = '',
        residentialAddress = '',
        nationality = null,
        identityFileKey = null,
        addressFileKey = null,
        dateOfBirth = null,
        fieldsStatuses = null,
        legalForm = null,
        pki
    } = {} as Partial<UboIdentity>) {
        const dateOfBirthInstance = moment(dateOfBirth, DateTimeFormatRepository.Default);

        this.fullName = fullName;
        this.dateOfBirth = when(
            dateOfBirthInstance.isValid(),
            dateOfBirthInstance,
            null
        );
        this.residentialAddress = residentialAddress;
        this.nationality = nationality;
        this.identityFileKey = identityFileKey;
        this.addressFileKey = addressFileKey;
        this.fieldsStatuses = fieldsStatuses;
        this.legalForm = legalForm;
        this.pki = pki;
    }
};

export default Identity;
